import adminSettingsNavTemplate from './nav/template.html';
import AdminSettingsNavCtrl from './nav';
import adminSettingsDepartmentsTemplate from './departments/template.html';
import AdminSettingsDepartmentsCtrl from './departments';
import adminSettingsEmailTemplatesTemplate from './emailTemplates/get/template.html';
import AdminSettingsEmailTemplatesCtrl from './emailTemplates/get/index';
import adminSettingsEmailTemplatesIdTemplate from './emailTemplates/edit/template.html';
import AdminSettingsEmailTemplatesIdCtrl from './emailTemplates/edit/index';
import adminSettingsFormsTemplate from './forms/template.html';
import AdminSettingsFormsCtrl from './forms/index';
import AdminSettingsIntegrationsCtrl from './integrations/get/index';
import adminSettingsIntegrationsTemplate from './integrations/get/template.html';
import AdminSettingsIntegrationsIdCtrl from './integrations/edit/index';
import adminSettingsIntegrationsIdTemplate from './integrations/edit/template.html';
import adminSettingsCompanyTemplate from './company/template.html';
import AdminSettingsCompanyCtrl from './company';
import adminSettingsLevelsTemplate from './levels/template.html';
import AdminSettingsLevelsCtrl from './levels';
import adminSettingsLocationsTemplate from './locations/template.html';
import AdminSettingsLocationsCtrl from './locations';
import adminSettingsPracticeAreasTemplate from './practiceAreas/template.html';
import AdminSettingsPracticeAreasCtrl from './practiceAreas';
import adminSettingsTagsTemplate from './tags/get/template.html';
import AdminSettingsTagsCtrl from './tags/get/index';
import adminSettingsTagsIdTemplate from './tags/edit/template.html';
import AdminSettingsTagsIdCtrl from './tags/edit/index';
import adminSettingsTeamsTemplate from './teams/get/template.html';
import AdminSettingsTeamsCtrl from './teams/get/index';
import adminSettingsTeamsIdTemplate from './teams/edit/template.html';
import AdminSettingsTeamsIdCtrl from './teams/edit/index';
import adminSettingsUsersTemplate from './users/template.html';
import AdminSettingsUsersCtrl from './users';

const adminSettingsNavState = {
  url: '/settings',
  stateName: 'Settings',
  abstract: true,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: adminSettingsNavTemplate,
      controller: AdminSettingsNavCtrl,
      controllerAs: 'adminSettingsTabsCtrl'
    }
  }
};

const adminSettingsCompanyState = {
  url: '/company',
  stateName: 'Company',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/company')
  },
  views: {
    a: {
      template: adminSettingsCompanyTemplate,
      controller: AdminSettingsCompanyCtrl,
      controllerAs: 'adminSettingsCompanyCtrl'
    }
  }
};

const adminSettingsDepartmentsState = {
  url: '/departments',
  stateName: 'Departments',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/departments')
  },
  views: {
    a: {
      template: adminSettingsDepartmentsTemplate,
      controller: AdminSettingsDepartmentsCtrl,
      controllerAs: 'adminSettingsDepartmentsCtrl'
    }
  }
};

const adminSettingsEmailTemplatesState = {
  url: '/emails',
  stateName: 'Email Settings',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/emails')
  },
  views: {
    a: {
      template: adminSettingsEmailTemplatesTemplate,
      controller: AdminSettingsEmailTemplatesCtrl,
      controllerAs: 'adminSettingsEmailTemplatesCtrl'
    }
  }
};

const adminSettingsEmailTemplatesIdState = {
  url: '/:type_id',
  stateName: 'Email Template Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/settings/emails/:type_id')
  },
  views: {
    'a@app.admin.settings': {
      template: adminSettingsEmailTemplatesIdTemplate,
      controller: AdminSettingsEmailTemplatesIdCtrl,
      controllerAs: 'adminSettingsEmailTemplatesIdCtrl'
    }
  }
};

const adminSettingsFormsState = {
  url: '/forms',
  stateName: 'Forms Settings',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/forms')
  },
  views: {
    a: {
      template: adminSettingsFormsTemplate,
      controller: AdminSettingsFormsCtrl,
      controllerAs: 'adminSettingsFormsCtrl'
    }
  }
};

const adminSettingsIntegrationsState = {
  url: '/integrations',
  stateName: 'Integrations',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/settings/integrations')
  },
  views: {
    a: {
      template: adminSettingsIntegrationsTemplate,
      controller: AdminSettingsIntegrationsCtrl,
      controllerAs: 'adminSettingsIntegrationsCtrl'
    }
  }
};

const adminSettingsIntegrationsIdState = {
  url: '/:type_id?code',
  stateName: 'Integrations Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  parmas: {
    code: {
      type: 'string',
      squash: false
    }
  },
  views: {
    'a@app.admin.settings': {
      template: adminSettingsIntegrationsIdTemplate,
      controller: AdminSettingsIntegrationsIdCtrl,
      controllerAs: 'adminSettingsIntegrationsIdCtrl'
    }
  }
};

const adminSettingsLevelsState = {
  url: '/levels',
  stateName: 'Levels',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/levels')
  },
  views: {
    a: {
      template: adminSettingsLevelsTemplate,
      controller: AdminSettingsLevelsCtrl,
      controllerAs: 'adminSettingsLevelsCtrl'
    }
  }
};

const adminSettingsLocationsState = {
  url: '/locations',
  stateName: 'Locations',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/locations')
  },
  views: {
    a: {
      template: adminSettingsLocationsTemplate,
      controller: AdminSettingsLocationsCtrl,
      controllerAs: 'adminSettingsLocationsCtrl'
    }
  }
};

const adminSettingsPracticeAreasState = {
  url: '/practice-areas',
  stateName: 'Practice Areas',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/settings/practice-areas')
  },
  views: {
    a: {
      template: adminSettingsPracticeAreasTemplate,
      controller: AdminSettingsPracticeAreasCtrl,
      controllerAs: 'adminSettingsPracticeAreasCtrl'
    }
  }
};

const adminSettingsTagsState = {
  url: '/tags',
  stateName: 'Tags',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/tags')
  },
  views: {
    a: {
      template: adminSettingsTagsTemplate,
      controller: AdminSettingsTagsCtrl,
      controllerAs: 'adminSettingsTagsCtrl'
    }
  }
};

const adminSettingsTagsIdState = {
  url: '/:type_id',
  stateName: 'Tag Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.settings': {
      template: adminSettingsTagsIdTemplate,
      controller: AdminSettingsTagsIdCtrl,
      controllerAs: 'adminSettingsTagsIdCtrl'
    }
  }
};

const adminSettingsTeamsState = {
  url: '/teams',
  stateName: 'Teams',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/teams')
  },
  views: {
    a: {
      template: adminSettingsTeamsTemplate,
      controller: AdminSettingsTeamsCtrl,
      controllerAs: 'adminSettingsTeamsCtrl'
    }
  }
};

const adminSettingsTeamsIdState = {
  url: '/:type_id',
  stateName: 'Team Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.admin.settings': {
      template: adminSettingsTeamsIdTemplate,
      controller: AdminSettingsTeamsIdCtrl,
      controllerAs: 'adminSettingsTeamsIdCtrl'
    }
  }
};

const adminSettingsUsersState = {
  url: '/users',
  stateName: 'Users',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/settings/users')
  },
  views: {
    a: {
      template: adminSettingsUsersTemplate,
      controller: AdminSettingsUsersCtrl,
      controllerAs: 'adminSettingsUsersCtrl'
    }
  }
};

export {
  adminSettingsNavState,
  adminSettingsDepartmentsState,
  adminSettingsEmailTemplatesState,
  adminSettingsEmailTemplatesIdState,
  adminSettingsFormsState,
  adminSettingsIntegrationsState,
  adminSettingsIntegrationsIdState,
  adminSettingsCompanyState,
  adminSettingsLevelsState,
  adminSettingsLocationsState,
  adminSettingsPracticeAreasState,
  adminSettingsTagsState,
  adminSettingsTagsIdState,
  adminSettingsTeamsState,
  adminSettingsTeamsIdState,
  adminSettingsUsersState
};



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/index.js